const e = "styles-module__loader_container___Jw1IO", s = "styles-module__spin___Yr0Qe", _ = {
  loader_container: e,
  spin: s
};
export {
  _ as default,
  e as loader_container,
  s as spin
};
